import { Navigate, Routes, Route } from "react-router-dom";

import ROUTES from "@app/common/routes";

import Integrations from "./Integrations";

const getRelativePath = (route: string) =>
  route.replace(ROUTES.INTEGRATIONS_ROOT, "");

const ROUTE_MIGRATIONS = [
  {
    oldPath: ROUTES.LEGACY.INTEGRATIONS_SLACK,
    newPath: ROUTES.INTEGRATIONS_WORKSPACE_SLACK,
  },
  {
    oldPath: ROUTES.LEGACY.INTEGRATIONS_WEBHOOKS,
    newPath: ROUTES.INTEGRATIONS_WEBHOOKS,
  },
  {
    oldPath: ROUTES.LEGACY.INTEGRATIONS_ZAPIER,
    newPath: ROUTES.INTEGRATIONS_ZAPIER,
  },
];

const IntegrationsRoutes = () => {
  return (
    <Routes>
      <Route path=":scope/*" element={<Integrations />} />

      {/* Backwards compatibility for the old routes */}
      {ROUTE_MIGRATIONS.map(({ oldPath, newPath }) => (
        <Route
          key={oldPath}
          path={getRelativePath(oldPath)}
          element={<Navigate to={newPath} replace />}
        />
      ))}
      <Route
        path="*"
        element={<Navigate to={ROUTES.INTEGRATIONS_DEFAULT_SECTION} replace />}
      />
    </Routes>
  );
};

export default IntegrationsRoutes;
